import {ThemeStyle} from '../../../../shared/constants/AppEnums';
import styled from 'styled-components';

export const AppMain = styled.div`
  ${({themeStyle, theme}) => ` 
      height: 100vh;
      display: flex;
      position: relative;
      padding-top: 56px;
      background-color: ${theme.palette.background.default};
      ${theme.breakpoints.up('sm')} {
        padding-top: 70px;
      }
      &.appMainFixedFooter {
        padding-bottom: 48px;
        ${theme.breakpoints.up('xl')} {
        padding-bottom: 58px;
        }
        & .scrollAppSidebar {
          height:
            ${
              themeStyle === 'Modern'
                ? 'calc(100vh - 260px) !important'
                : 'calc(100vh - 198px) !important'
            };
          ${theme.breakpoints.up('xl')} {
            height:
              ${
                themeStyle === 'Modern'
                  ? 'calc(100vh - 300px) !important'
                  : 'calc(100vh - 236px) !important'
              };
          }
        }
        & .main-container {
          padding-bottom: 1px;
        }
      }
      &.boxed-layout {
      ${theme.breakpoints.up('lg')} {
        max-width: 1260px;
        margin-left: auto;
        margin-right: auto;
        box-shadow: 0px 0px 4px 2px rgba(0,0,0,0.12);
        & .app-sidebar {
          position: absolute;
        }
        & .main-content {
          width: 100%;
          flex: auto;
        }
        & .main-container {
          width: calc(100% - 19rem);
        }
        & .app-bar {
          width: 100%;
          position: absolute;
          box-shadow: 0px 0px 4px 2px rgba(0,0,0,0.12);
        }
        & .grid-btn {
          font-size: 11px;
        }
      }
      ${theme.breakpoints.up('xl')} {
        max-width: 1680px;
        & .main-content, & .app-bar {
          width: 100%;
        }
      }
      }
`}
`;

export const MainContent = styled.div`
  flex: 1;
  display: flex;
`;

export const MainContainer = styled.div`
  ${({themeStyle, footer, theme}) => `  
  width: calc(100vw - ${themeStyle === ThemeStyle.MODERN ? '19rem' : '19rem'});
   padding-bottom: ${footer ? 0 : '10px'};
   
   ${theme.breakpoints.up('xl')} {
    width: calc(100vw - ${
      themeStyle === ThemeStyle.MODERN ? '22.8rem' : '21.6rem'
    });
   }
   
   & > .scrollbar-container {
        padding: 20px 20px 0;
        display: flex;
        flex-direction: column;
        
        ${theme.breakpoints.up('md')} {
         padding: 30px 32px 0;
        }
   }
`}
`;

export const MainContainerFull = styled.div`
  ${({footer, theme}) => `
      width: 100vw;
      padding-bottom: ${footer ? 0 : '10px'};
       & > .scrollbar-container {
        padding: 20px 20px 0;
        display: flex;
        flex-direction: column;
        ${theme.breakpoints.up('md')} {
         padding: 30px 32px 0;
        }
      }
`}
`;
